module.exports = __webpack_public_path__ + "img/user-header.fb3093e9.png";